import ReactDOM from 'react-dom';
import React from 'react';
import ColbyGivingButtons from './ColbyGivingButtons.js';

document.querySelectorAll('#colby-giving-buttons-root').forEach(elem => {
    ReactDOM.render(<ColbyGivingButtons />, elem);
});
